import React, { Component, Fragment } from 'react';

import { I18n } from 'components/translate';
import isNil from 'lodash/isNil';
import { BroadcastService } from 'modules/broadcastManager';
import {
  setClassesList,
  setQuizzesExerciseList,
  setQuizzesProfileList,
  setModulesTreeList,
  filtersRules,
  formatPages
} from 'modules/userManager/helper';
import DeepSearchContentService from 'modules/userManager/userSearch/deepSearch/content/DeepSearchContentService';
import PropTypes from 'prop-types';

import './BroadcastDetailFilters.scss';

export default class BroadcastDetailFilters extends Component {
  static propTypes = {
    messageId: PropTypes.string
  };

  state = {
    hasFilters: true,
    sentToAllUsers: false,
    filtersListStatus: [],
    content: [],
    access: [],
    user: []
  };

  fetchFiltersContentList = async () => {
    const {
      classesList,
      quizzesExerciseList,
      quizzesProfileList,
      modulesTreeList
    } = await DeepSearchContentService.getListsData();

    setClassesList(classesList);
    setQuizzesExerciseList(quizzesExerciseList);
    setQuizzesProfileList(quizzesProfileList);
    setModulesTreeList(modulesTreeList);
  };

  async componentDidMount() {
    const { messageId } = this.props;

    const response = await BroadcastService.getBroadcastFilters(messageId);

    if (isNil(response) || isNil(response.filters)) {
      this.setState({ hasFilters: false });
      return;
    }

    if (response.filters.length) {
      await this.fetchFiltersContentList();

      this.formatFilters(response.filters);
    } else {
      this.setState({ sentToAllUsers: true });
    }
  }

  formatFilters = (filtersGroup) => {
    const topics = {
      content: [],
      access: [],
      user: []
    };

    const pagesFilter = filtersGroup.find((filter) => filter._type === 'page');

    Object.keys(topics).forEach((topic) => {
      (filtersRules[topic] || []).forEach((topicFilter) => {
        let filterFound = null;

        if (topicFilter.title === 'page' && pagesFilter) {
          filterFound = formatPages(filtersGroup);
        } else {
          filterFound = filtersGroup.find(
            (filter) => filter._type === topicFilter.title
          );
        }

        filterFound &&
          topics[topic].push({
            title: topicFilter.title,
            value: topicFilter.value && topicFilter.value(filterFound),
            status: topicFilter.status && topicFilter.status(filterFound),
            values: topicFilter.values && topicFilter.values(filterFound)
          });
      });
    });

    this.setState({ ...topics });
  };

  isTheLastItem = (values, index) => index === values.length - 1;

  shouldRenderViewOptions = (values, index, defaultSize) =>
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    values.length > 2 && defaultSize !== 3 && this.isTheLastItem(values, index);

  findListStatusByIndex = (index) => {
    const { filtersListStatus } = this.state;

    return filtersListStatus.find(
      (filterListStatus) => filterListStatus.listOpenIndex === index
    );
  };

  updateListStatus = (index) => {
    this.setState((prevState) => ({
      filtersListStatus: prevState.filtersListStatus.map((listStatus) => {
        if (listStatus.listOpenIndex === index) {
          return { ...listStatus, isListOpen: !listStatus.isListOpen };
        }

        return listStatus;
      })
    }));
  };

  createListStatus = (index) => {
    this.setState((prevState) => ({
      filtersListStatus: prevState.filtersListStatus.concat([
        {
          isListOpen: true,
          listOpenIndex: index
        }
      ])
    }));
  };

  changeFilterListStatus = (index) => {
    const listStatus = this.findListStatusByIndex(index);

    if (listStatus) {
      this.updateListStatus(index);
    } else {
      this.createListStatus(index);
    }
  };

  isListOpenAvaliable = (listStatus) => listStatus && listStatus.isListOpen;

  shoudlRenderAllValues = (values, listStatus) =>
    values && this.isListOpenAvaliable(listStatus);

  renderFilterValues = (values, parentIndex) => {
    const listStatus = this.findListStatusByIndex(parentIndex);
    const filters = this.shoudlRenderAllValues(values, listStatus)
      ? values
      : // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        values.slice(0, 3);

    return filters.map(
      (filter, index) =>
        filter && (
          <Fragment key={filter.title}>
            <h3>{filter.title}</h3>

            <h6>{filter.status}</h6>

            {this.shouldRenderViewOptions(filters, index, values.length) && (
              <h5 onClick={this.changeFilterListStatus.bind(this, parentIndex)}>
                <I18n
                  label={
                    this.isListOpenAvaliable(listStatus)
                      ? 'general.view_less'
                      : 'general.view_more'
                  }
                />
              </h5>
            )}
          </Fragment>
        )
    );
  };

  renderTopic = (topic) => {
    return this.state[topic].map((filter, index) => (
      <div key={filter.title} className="filter__item">
        {index === 0 && (
          <h1>
            <I18n label={`general.${topic}`} />
          </h1>
        )}
        <h2>
          <I18n label={`broadcast.filters_titles.${filter.title}`} />
        </h2>

        {filter.value && <h3>{filter.value}</h3>}

        {filter.status && <h4>{filter.status}</h4>}

        {filter.values && this.renderFilterValues(filter.values, index)}
      </div>
    ));
  };

  renderTopics() {
    const topics = ['content', 'access', 'user'];

    const components = topics.map((topic) => {
      return (
        <div key={topic} className="filter__type">
          {this.renderTopic(topic)}
        </div>
      );
    });

    return components;
  }

  render() {
    const { hasFilters } = this.state;

    return (
      <div className="broadcast__modal">
        <h1>
          <I18n label="broadcast.modal.filters.filters_applied" />
        </h1>

        <div className="broadcast__modal__filters">
          {hasFilters ? (
            this.renderHasFilters()
          ) : (
            <p>
              <I18n label="broadcast.modal.filters.none_filters_applied" />
            </p>
          )}
        </div>
      </div>
    );
  }

  renderHasFilters() {
    const { sentToAllUsers } = this.state;

    if (sentToAllUsers) {
      return (
        <p>
          <I18n label="broadcast.modal.filters.sent_to_all_users" />
        </p>
      );
    }

    return (
      <Fragment>
        <p>
          <I18n label="broadcast.modal.filters.check_the_applied_filters_in_broadcast" />
        </p>

        {this.renderTopics()}
      </Fragment>
    );
  }
}
